import { FormErrors } from 'redux-form';

import { ShopifyCardState } from 'components/settings/reducers/sections/shopifyCards';

import type { ValidateErrors } from '../cards.types';

export function validate(values: ShopifyCardState): FormErrors {
  const errors: ValidateErrors = { hook: {} };

  if (!values) {
    return errors;
  }

  if (!values?.hook?.title?.trim()) {
    errors.hook.title = 'Please add a title';
  }

  if (!values?.hook?.api_key?.trim()) {
    errors.hook.api_key = 'Please add an api key';
  }

  if (!values?.hook?.password?.trim()) {
    errors.hook.password = 'Please add an api password';
  }

  if (!values?.hook?.shopifySubdomain?.trim()) {
    errors.hook.shopifySubdomain = 'Please add a shopify subdomain';
  } else {
    const invalidProtocols = ['https://', 'http://'];
    const protocol = invalidProtocols.find((value) =>
      values.hook.shopifySubdomain.includes(value),
    );
    const hasTrailingSlash = values.hook.shopifySubdomain.endsWith('/');

    const protocolErrorMessage = protocol
      ? `Please remove the protocol \`${protocol}\` from the hostname`
      : '';
    const trailingSlashErrorMessage = hasTrailingSlash
      ? 'Please remove the trailing `/` from the hostname'
      : '';

    if (protocolErrorMessage) {
      errors.hook.shopifySubdomain = protocolErrorMessage;
    }

    if (trailingSlashErrorMessage) {
      errors.hook.shopifySubdomain = trailingSlashErrorMessage;
    }

    if (protocolErrorMessage && trailingSlashErrorMessage) {
      errors.hook.shopifySubdomain = `Please remove the protocol \`${protocol}\` and the trailing \`/\` from the hostname`;
    }
  }

  if (!values?.template) {
    errors.template = 'Please add some template content';
  }

  return errors;
}

export const apiKeyHelpText = `Please insert the API key corresponding to the Shopify account that you want Dixa to receive data from.`;
export const apiPasswordHelpText = `Please insert the API Password corresponding to the Shopify account that you want Dixa to receive data from.`;
export const subdomainHelpText =
  'Please insert your Shopify subdomain name here. Example: `mydomain.shopify.com`';
